import type { KeyboardEvent, RefObject } from 'react';

type Tab = { id: string };

export const useTabListKeyNav =
  (
    tabs: Tab[],
    activeTabId: string,
    setActiveTabId: (id: string) => void,
    tabRefs: RefObject<(HTMLButtonElement | null)[]>,
  ) =>
  (e: KeyboardEvent) => {
    if (tabs.length === 0) {
      return;
    }
    const found = tabs.findIndex((t) => t.id === activeTabId);
    const currentIndex = found === -1 ? 0 : found;
    let nextIndex: number;

    switch (e.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    setActiveTabId(tabs[nextIndex].id);
    tabRefs.current[nextIndex]?.focus();
  };
